import { NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { SmartadminLayoutModule } from "./layout";

import {I18nModule} from "./i18n/i18n.module";
import {UtilsModule} from "./utils/utils.module";
import { BootstrapModule } from "@app/shared/bootstrap.module";
import {PipesModule} from "./pipes/pipes.module";
import { ReactiveFormsModule } from '@angular/forms';
// import { UserModule } from "./user/user.module";
// import {VoiceControlModule} from "./voice-control/voice-control.module";
 import {SmartadminWidgetsModule} from "./widgets/smartadmin-widgets.module";
import { FormlyModule } from "@ngx-formly/core";
import { FORMLY_COMPONENTS, NgFormlyConfig } from "./dynamicform/formly";
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import {TimeLineModule} from '@app/shared/time-line/time-line.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { OwlcalenderComponent } from '@app/shared/ui/owlcalender/owlcalender.component';
import { DropzoneModule } from '@app/shared/forms/dropzone/dropzone.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    SmartadminLayoutModule,
    BootstrapModule,
    ReactiveFormsModule,
    SmartadminWidgetsModule,
    FormlyModule.forRoot(NgFormlyConfig),
    TimeLineModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgSelectModule,
    DropzoneModule
  ],
  declarations: [
    FORMLY_COMPONENTS,
    OwlcalenderComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    // UserModule,
    SmartadminLayoutModule,
    BootstrapModule,

    I18nModule,

    UtilsModule,
    PipesModule,

    // SmartadminFormsLiteModule,

    // SmartProgressbarModule,

    // InlineGraphsModule,

     SmartadminWidgetsModule,

    // ChatModule,

    // StatsModule,

    // VoiceControlModule,

    // CalendarComponentsModule,
    FormlyModule,
    FormlyBootstrapModule,
    TimeLineModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlcalenderComponent,
    DropzoneModule
  ]
})
export class SharedModule {}
